var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSecurity(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.8314 18.0904C27.8314 25.0483 22.9608 28.5272 17.1719 30.545C16.8688 30.6477 16.5395 30.6428 16.2395 30.5311C10.4367 28.5272 5.56616 25.0483 5.56616 18.0904V8.34939C5.56616 7.98033 5.71277 7.62637 5.97375 7.3654C6.23472 7.10443 6.58867 6.95782 6.95774 6.95782C9.74089 6.95782 13.2198 5.28793 15.6412 3.17274C15.936 2.92086 16.311 2.78247 16.6988 2.78247C17.0865 2.78247 17.4615 2.92086 17.7564 3.17274C20.1916 5.30185 23.6566 6.95782 26.4398 6.95782C26.8088 6.95782 27.1628 7.10443 27.4238 7.3654C27.6847 7.62637 27.8314 7.98033 27.8314 8.34939V18.0904Z",
    stroke: "#2A2A2A",
    strokeWidth: 2.78315,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurity);
export default __webpack_public_path__ + "static/media/security.6735d63b75e3abb813d629f2646fea3f.svg";
export { ForwardRef as ReactComponent };